export default {
    getChineseNumber(num){
        switch (Number(num)) {
            case 1:
                return '一'
                break;
            case 2:
                return '二'
                break;
            case 3:
                return '三'
                break;
            case 4:
                return '四'
                break;
            case 5:
                return '五'
                break;
            case 6:
                return '六'
                break;
            case 7:
                return '七'
                break;
            case 8:
                return '八'
                break;
            case 9:
                return '九'
                break;
            case 10:
                return '十'
                break;
        }
    },
    storage(key, val) { //本地存储
        if (val) {
            localStorage.setItem(key, JSON.stringify(val))
        } else {
            return JSON.parse(localStorage.getItem(key))
        }
    },
    getObjectInArrayByValue(source,aims){//得到数组中的对象中对应值在数组中的位置
        for(let i = 0; i < source.length; i++){
            for(let item in aims){
                if(aims[item] && source[i][item] == aims[item]){
                    return i
                }
            }
        }
        return -1
    },
    formatNum(f, digit) { 
        var m = Math.pow(10, digit); 
        return parseInt(f * m, 10) / m; 
    }
}


// WEBPACK FOOTER //
// ./packages/question-assembly/src/utils.js